
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './NoteApp.css';

// Example keyword-to-tag mapping
const initialTagSuggestions = {
  work: ["project", "meeting", "deadline"],
  personal: ["groceries", "diary", "vacation"],
  ideas: ["startup", "invention", "plan"],
  education: ["study", "exam", "homework"],
  uncategorized: [],
};

const NoteApp = () => {
  const [notes, setNotes] = useState({ uncategorized: [] });
  const [newId, setNewId] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [suggestedTags, setSuggestedTags] = useState(['uncategorized']);
  const [selectedTag, setSelectedTag] = useState('uncategorized');
  const [tagSuggestions, setTagSuggestions] = useState(initialTagSuggestions);
  const [customTag, setCustomTag] = useState('');

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        const response = await axios.get('http://localhost:5000/api/notes');
        setNotes(groupNotesByTag(response.data));
      } catch (error) {
        console.error('Error fetching notes:', error);
      }
    };

    fetchNotes();
  }, []);

  // Suggest tags based on title
  const suggestTags = (title) => {
    const matchingTags = ['uncategorized']; // Default tag
    for (const [tag, keywords] of Object.entries(tagSuggestions)) {
      if (keywords.some(keyword => title.toLowerCase().includes(keyword))) {
        matchingTags.push(tag);
      }
    }
    setSuggestedTags(matchingTags);
    setSelectedTag(matchingTags[0]); 
  };

  // Add custom tag
  const handleAddCustomTag = () => {
    if (customTag && !Object.keys(tagSuggestions).includes(customTag)) {
      setTagSuggestions(prevSuggestions => ({
        ...prevSuggestions,
        [customTag]: []
      }));
      setSuggestedTags(prevTags => [...prevTags, customTag]);
      setCustomTag(''); // Clear input field
    }
  };

  const groupNotesByTag = (notesArray) => {
  return notesArray.reduce((groupedNotes, note) => {
    const tag = note.tag || 'uncategorized';
    if (!groupedNotes[tag]) {
      groupedNotes[tag] = [];
    }
    groupedNotes[tag].push(note);
    return groupedNotes;
  }, {});
};

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const newNote = { title, content, tag: selectedTag ,};
      
      // Send the new note to the backend server
      await axios.post('http://localhost:5000/api/notes', newNote);
  
      // Fetch the latest notes after submission (or you can manually update the state)
      const response = await axios.get('http://localhost:5000/api/notes');
      setNotes(groupNotesByTag(response.data)); // Assume you have a function that groups notes by tag
      const newId = 
      // Clear input fields
      setTitle('');
      setContent('');
    } catch (error) {
      console.error('Error adding note:', error);
    }
  };

  const handleDelete = async (noteId) => {
    try {
      // Send DELETE request to backend
      await axios.delete(`http://localhost:5000/api/notes/${noteId}`);
  
      // Fetch the updated notes from the backend after deletion
      const response = await axios.get('http://localhost:5000/api/notes');
      setNotes(groupNotesByTag(response.data)); // Re-group the notes by tag
    } catch (error) {
      console.error('Error deleting note:', error);
    }
  };

  return (
    <div className='App-container'>
      <h1 className='head'>Note Storage Without ID</h1>
         <div className='note-form'>
        <input
          type='text'
          placeholder='Title'
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            suggestTags(e.target.value); // Update suggested tags based on title
          }}
          required
        />
        <textarea
          placeholder='Content'
          rows={10}
          id = "body"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          required
        />

        {/* Tag Buttons */}
        <div className="tag-buttons">
          <label>Choose a Tag:</label>
          <div className="tag-buttons-container">
            {suggestedTags.map(tag => (
              <button
                key={tag}
                type="button"
                className={`tag-button ${selectedTag === tag ? 'selected' : ''}`}
                onClick={() => setSelectedTag(tag)}
              >
                {tag.charAt(0).toUpperCase() + tag.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {/* Custom Tag Input */}
        <div className="custom-tag">
          <input
            type="text"
            placeholder="Add custom tag"
            value={customTag}
            onChange={(e) => setCustomTag(e.target.value)}
          />
          <button type="button" onClick={handleAddCustomTag}>
            Add Tag
          </button>
        </div>

        <button onClick={handleSubmit}>Add Note</button>
      </div>

      <div className='notes-grid'>
        {Object.keys(notes).map(tag => (
          
          <div key={tag} className='notes-section'>
            <h2>{tag.charAt(0).toUpperCase() + tag.slice(1)}</h2>
            {notes[tag].map((note) => (
  <div className='note-item' key={note._id}>
    <div className='notes-header'>
      <button onClick={() => handleDelete(note._id)}>x</button>
    </div>
    <h2>{note.title}</h2>
    <p>{note.content}</p>
  </div>
))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NoteApp;



